// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   InputAdornment,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Alert,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import {
//   Search,
//   Visibility,
//   Delete,
// } from '@mui/icons-material';
// import apiService from '../services/apiService';

// const RidesPage = () => {
//   const [rides, setRides] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRide, setSelectedRide] = useState(null);

//   const fetchRides = useCallback(async () => {
//     try {
//       setLoading(true);
//       const params = {};
//       if (statusFilter !== 'all') {
//         params.status = statusFilter;
//       }
//       if (searchQuery.trim()) {
//         params.search = searchQuery.trim();
//       }

//       const response = await apiService.getRides(params);

//       if (response.success) {
//         setRides(response.data);
//       } else {
//         setError(response.message || 'Failed to load rides');
//         setRides([]);
//       }
//     } catch (err) {
//       console.error('Rides error:', err);
//       setError('Failed to load rides');
//       setRides([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [statusFilter, searchQuery]);

//   useEffect(() => {
//     fetchRides();
//   }, [fetchRides]);

//   const handleViewRide = async (ride) => {
//     setSelectedRide(ride);
//     setOpenDialog(true);
//   };

//   const handleDeleteRide = async (rideId) => {
//     if (!window.confirm('Are you sure you want to delete this ride? This action cannot be undone.')) {
//       return;
//     }

//     try {
//       const response = await apiService.deleteRide(rideId);
//       if (response.success) {
//         alert('Ride deleted successfully');
//         fetchRides();
//       } else {
//         alert(response.message || 'Failed to delete ride');
//       }
//     } catch (err) {
//       console.error('Delete ride error:', err);
//       alert('Failed to delete ride');
//     }
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       searching_driver: { label: 'Searching Driver', color: 'warning' },
//       driver_assigned: { label: 'Driver Assigned', color: 'info' },
//       driver_arrived: { label: 'Driver Arrived', color: 'info' },
//       in_progress: { label: 'In Progress', color: 'primary' },
//       completed: { label: 'Completed', color: 'success' },
//       cancelled: { label: 'Cancelled', color: 'error' },
//     };

//     const config = statusConfig[status] || { label: status, color: 'default' };
//     return <Chip label={config.label} color={config.color} size="small" />;
//   };

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleString('en-IN', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch {
//       return dateString;
//     }
//   };

//   const columns = [
//     {
//       field: 'crn',
//       headerName: 'CRN',
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2" fontWeight={600} sx={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>
//           {params.row.crn || params.row.id?.substring(0, 12) + '...'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'passengerName',
//       headerName: 'Passenger',
//       width: 130,
//       renderCell: (params) => params.row.passengerName || '-',
//     },
//     {
//       field: 'driverName',
//       headerName: 'Driver',
//       width: 130,
//       renderCell: (params) => params.row.driverName || '-',
//     },
//     {
//       field: 'vehicleType',
//       headerName: 'Vehicle',
//       width: 120,
//       renderCell: (params) => (
//         <Box>
//           <Typography variant="body2" fontWeight={500}>
//             {params.row.vehicleType || '-'}
//           </Typography>
//           {params.row.vehicleNumber && (
//             <Typography variant="caption" color="text.secondary">
//               {params.row.vehicleNumber}
//             </Typography>
//           )}
//         </Box>
//       ),
//     },
//     {
//       field: 'pickupLocation',
//       headerName: 'Pickup',
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2" noWrap title={params.row.pickupLocation}>
//           {params.row.pickupLocation || '-'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'dropLocation',
//       headerName: 'Drop',
//       width: 180,
//       renderCell: (params) => (
//         <Typography variant="body2" noWrap title={params.row.dropLocation}>
//           {params.row.dropLocation || '-'}
//         </Typography>
//       ),
//     },
//     {
//       field: 'fare',
//       headerName: 'Fare',
//       width: 100,
//       renderCell: (params) => {
//         const fare = params.row.fare || params.row.finalFare || params.row.estimatedFare;
//         return fare > 0 ? `₹${parseFloat(fare).toFixed(0)}` : '-';
//       },
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 150,
//       renderCell: (params) => getStatusChip(params.row.status),
//     },
//     {
//       field: 'createdAt',
//       headerName: 'Created',
//       width: 160,
//       renderCell: (params) => formatDate(params.row.createdAt),
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 120,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleViewRide(params.row)}>
//             <Visibility fontSize="small" />
//           </IconButton>
//           <IconButton
//             size="small"
//             color="error"
//             onClick={() => handleDeleteRide(params.row.id)}
//           >
//             <Delete fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   // Server-side search is now used - filteredRides directly uses rides
//   const filteredRides = rides;

//   return (
//     <Box>
//       <Box sx={{ mb: 3 }}>
//         <Typography variant="h4" fontWeight="bold" gutterBottom>
//           Rides
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           View and manage all rides
//         </Typography>
//       </Box>

//       {error && (
//         <Alert severity="warning" sx={{ mb: 3 }}>
//           {error} - Showing demo data
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
//             <TextField
//               placeholder="Search by CRN, passenger, or driver..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               onKeyDown={(e) => { if (e.key === 'Enter') fetchRides(); }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ flexGrow: 1 }}
//             />
//             <FormControl sx={{ minWidth: 180 }}>
//               <InputLabel>Status</InputLabel>
//               <Select
//                 value={statusFilter}
//                 onChange={(e) => setStatusFilter(e.target.value)}
//                 label="Status"
//               >
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="searching_driver">Searching Driver</MenuItem>
//                 <MenuItem value="driver_assigned">Driver Assigned</MenuItem>
//                 <MenuItem value="in_progress">In Progress</MenuItem>
//                 <MenuItem value="completed">Completed</MenuItem>
//                 <MenuItem value="cancelled">Cancelled</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>

//           <DataGrid
//             rows={filteredRides}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* View Ride Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>Ride Details</DialogTitle>
//         <DialogContent>
//           {selectedRide && (
//             <Box sx={{ pt: 2 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <Typography variant="h6" fontWeight={600} gutterBottom sx={{ fontFamily: 'monospace' }}>
//                     CRN: {selectedRide.crn || 'N/A'}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
//                     Ride ID: {selectedRide.id}
//                   </Typography>
//                   <Box sx={{ mb: 2 }}>{getStatusChip(selectedRide.status)}</Box>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Passenger</Typography>
//                   <Typography variant="body1" fontWeight={600}>{selectedRide.passengerName || '-'}</Typography>
//                   {selectedRide.passengerPhone && (
//                     <Typography variant="body2" color="text.secondary">{selectedRide.passengerPhone}</Typography>
//                   )}
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Driver</Typography>
//                   <Typography variant="body1" fontWeight={600}>
//                     {selectedRide.driverName || 'Not assigned'}
//                   </Typography>
//                   {selectedRide.driverPhone && (
//                     <Typography variant="body2" color="text.secondary">{selectedRide.driverPhone}</Typography>
//                   )}
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Vehicle Type</Typography>
//                   <Typography variant="body1">{selectedRide.vehicleType || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Vehicle Number</Typography>
//                   <Typography variant="body1">{selectedRide.vehicleNumber || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="body2" color="text.secondary">Pickup Location</Typography>
//                   <Typography variant="body1">{selectedRide.pickupLocation || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Typography variant="body2" color="text.secondary">Drop Location</Typography>
//                   <Typography variant="body1">{selectedRide.dropLocation || '-'}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Distance</Typography>
//                   <Typography variant="body1">
//                     {selectedRide.distance > 0 ? `${parseFloat(selectedRide.distance).toFixed(1)} km` : '-'}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Fare</Typography>
//                   <Typography variant="body1" fontWeight={600} color="primary.main">
//                     {(selectedRide.fare || selectedRide.finalFare || selectedRide.estimatedFare) > 0
//                       ? `₹${parseFloat(selectedRide.fare || selectedRide.finalFare || selectedRide.estimatedFare).toFixed(0)}`
//                       : '-'}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Payment Method</Typography>
//                   <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
//                     {selectedRide.paymentMethod || '-'}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Payment Status</Typography>
//                   <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
//                     {selectedRide.paymentStatus || '-'}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">Created At</Typography>
//                   <Typography variant="body1">{formatDate(selectedRide.createdAt)}</Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Typography variant="body2" color="text.secondary">
//                     {selectedRide.status === 'completed' ? 'Completed At' :
//                      selectedRide.status === 'cancelled' ? 'Cancelled At' : 'Accepted At'}
//                   </Typography>
//                   <Typography variant="body1">
//                     {formatDate(selectedRide.completedAt || selectedRide.cancelledAt || selectedRide.acceptedAt)}
//                   </Typography>
//                 </Grid>
//                 {selectedRide.cancellationReason && (
//                   <Grid item xs={12}>
//                     <Typography variant="body2" color="text.secondary">Cancellation Reason</Typography>
//                     <Typography variant="body1" color="error.main">{selectedRide.cancellationReason}</Typography>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default RidesPage;


import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Paper,
  CircularProgress,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Search,
  Visibility,
  Delete,
  LocationOn,
  Directions,
  Place,
  MyLocation,
} from '@mui/icons-material';
import { GoogleMap, LoadScript, DirectionsRenderer, Marker, InfoWindow } from '@react-google-maps/api';
import apiService from '../services/apiService';

// Google Maps API Key
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Map container style
const containerStyle = {
  width: '100%',
  height: '500px',
};

// Default center (India)
const defaultCenter = {
  lat: 20.5937,
  lng: 78.9629,
};

const RidesPage = () => {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRide, setSelectedRide] = useState(null);
  const [mapTab, setMapTab] = useState(0);
  const [directions, setDirections] = useState(null);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [mapZoom, setMapZoom] = useState(12);
  const [directionsLoading, setDirectionsLoading] = useState(false);
  const [showInfoWindow, setShowInfoWindow] = useState(null);
  const mapRef = useRef(null);

  const fetchRides = useCallback(async () => {
    try {
      setLoading(true);
      const params = {};
      if (statusFilter !== 'all') {
        params.status = statusFilter;
      }
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }

      const response = await apiService.getRides(params);

      if (response.success) {
        setRides(response.data);
      } else {
        setError(response.message || 'Failed to load rides');
        setRides([]);
      }
    } catch (err) {
      console.error('Rides error:', err);
      setError('Failed to load rides');
      setRides([]);
    } finally {
      setLoading(false);
    }
  }, [statusFilter, searchQuery]);

  useEffect(() => {
    fetchRides();
  }, [fetchRides]);

  // Calculate midpoint between two coordinates
  const calculateMidpoint = (lat1, lon1, lat2, lon2) => {
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const lat1Rad = lat1 * Math.PI / 180;
    const lat2Rad = lat2 * Math.PI / 180;
    const lon1Rad = lon1 * Math.PI / 180;

    const Bx = Math.cos(lat2Rad) * Math.cos(dLon);
    const By = Math.cos(lat2Rad) * Math.sin(dLon);
    const lat3 = Math.atan2(
      Math.sin(lat1Rad) + Math.sin(lat2Rad),
      Math.sqrt((Math.cos(lat1Rad) + Bx) * (Math.cos(lat1Rad) + Bx) + By * By)
    );
    const lon3 = lon1Rad + Math.atan2(By, Math.cos(lat1Rad) + Bx);

    return {
      lat: lat3 * 180 / Math.PI,
      lng: lon3 * 180 / Math.PI
    };
  };

  // Calculate distance between two coordinates (Haversine formula)
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  // Calculate optimal zoom level based on distance
  const calculateZoomLevel = (distance) => {
    if (distance < 1) return 15;
    if (distance < 2) return 14;
    if (distance < 5) return 13;
    if (distance < 10) return 12;
    if (distance < 20) return 11;
    if (distance < 50) return 10;
    if (distance < 100) return 9;
    return 8;
  };

  const handleViewRide = async (ride) => {
    setSelectedRide(ride);
    setOpenDialog(true);
    setMapTab(0);
    setDirections(null);
    
    // Center map between pickup and drop
    if (ride.pickupLat && ride.pickupLng && ride.dropLat && ride.dropLng) {
      const pickupLat = parseFloat(ride.pickupLat);
      const pickupLng = parseFloat(ride.pickupLng);
      const dropLat = parseFloat(ride.dropLat);
      const dropLng = parseFloat(ride.dropLng);
      
      // Calculate midpoint
      const midpoint = calculateMidpoint(pickupLat, pickupLng, dropLat, dropLng);
      setMapCenter(midpoint);
      
      // Calculate distance and set zoom
      const distance = calculateDistance(pickupLat, pickupLng, dropLat, dropLng);
      const zoom = calculateZoomLevel(distance);
      setMapZoom(zoom);
      
      // Fetch directions
      await fetchDirections(ride);
    }
  };

  const fetchDirections = async (ride) => {
    if (!ride.pickupLat || !ride.pickupLng || !ride.dropLat || !ride.dropLng) {
      return;
    }

    setDirectionsLoading(true);
    try {
      const origin = `${ride.pickupLat},${ride.pickupLng}`;
      const destination = `${ride.dropLat},${ride.dropLng}`;
      
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/directions/json?origin=${origin}&destination=${destination}&key=${GOOGLE_MAPS_API_KEY}`
      );
      
      const data = await response.json();
      
      if (data.status === 'OK') {
        setDirections(data);
      } else {
        console.error('Directions API error:', data.status);
        setDirections(null);
      }
    } catch (error) {
      console.error('Error fetching directions:', error);
      setDirections(null);
    } finally {
      setDirectionsLoading(false);
    }
  };

  // Fit bounds to show both pickup and drop locations
  const fitBounds = () => {
    if (!selectedRide || !mapRef.current) return;
    
    const pickupLat = parseFloat(selectedRide.pickupLat);
    const pickupLng = parseFloat(selectedRide.pickupLng);
    const dropLat = parseFloat(selectedRide.dropLat);
    const dropLng = parseFloat(selectedRide.dropLng);
    
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: pickupLat, lng: pickupLng });
    bounds.extend({ lat: dropLat, lng: dropLng });
    
    mapRef.current.fitBounds(bounds);
    
    // Add some padding
    const listener = window.google.maps.event.addListener(mapRef.current, 'idle', () => {
      mapRef.current.setZoom(mapRef.current.getZoom() - 0.5);
      window.google.maps.event.removeListener(listener);
    });
  };

  const handleDeleteRide = async (rideId) => {
    if (!window.confirm('Are you sure you want to delete this ride? This action cannot be undone.')) {
      return;
    }

    try {
      const response = await apiService.deleteRide(rideId);
      if (response.success) {
        alert('Ride deleted successfully');
        fetchRides();
      } else {
        alert(response.message || 'Failed to delete ride');
      }
    } catch (err) {
      console.error('Delete ride error:', err);
      alert('Failed to delete ride');
    }
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      searching_driver: { label: 'Searching Driver', color: 'warning' },
      driver_assigned: { label: 'Driver Assigned', color: 'info' },
      driver_arrived: { label: 'Driver Arrived', color: 'info' },
      in_progress: { label: 'In Progress', color: 'primary' },
      completed: { label: 'Completed', color: 'success' },
      cancelled: { label: 'Cancelled', color: 'error' },
    };

    const config = statusConfig[status] || { label: status, color: 'default' };
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  const columns = [
    {
      field: 'crn',
      headerName: 'CRN',
      width: 180,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: '0.8rem', fontFamily: 'monospace' }}>
          {params.row.crn || params.row.id?.substring(0, 12) + '...'}
        </Typography>
      ),
    },
    {
      field: 'passengerName',
      headerName: 'Passenger',
      width: 130,
      renderCell: (params) => params.row.passengerName || '-',
    },
    {
      field: 'driverName',
      headerName: 'Driver',
      width: 130,
      renderCell: (params) => params.row.driverName || '-',
    },
    {
      field: 'vehicleType',
      headerName: 'Vehicle',
      width: 120,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2" fontWeight={500}>
            {params.row.vehicleType || '-'}
          </Typography>
          {params.row.vehicleNumber && (
            <Typography variant="caption" color="text.secondary">
              {params.row.vehicleNumber}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: 'pickupLocation',
      headerName: 'Pickup',
      width: 180,
      renderCell: (params) => (
        <Typography variant="body2" noWrap title={params.row.pickupLocation}>
          {params.row.pickupLocation || '-'}
        </Typography>
      ),
    },
    {
      field: 'dropLocation',
      headerName: 'Drop',
      width: 180,
      renderCell: (params) => (
        <Typography variant="body2" noWrap title={params.row.dropLocation}>
          {params.row.dropLocation || '-'}
        </Typography>
      ),
    },
    {
      field: 'fare',
      headerName: 'Fare',
      width: 100,
      renderCell: (params) => {
        const fare = params.row.fare || params.row.finalFare || params.row.estimatedFare;
        return fare > 0 ? `₹${parseFloat(fare).toFixed(0)}` : '-';
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      renderCell: (params) => getStatusChip(params.row.status),
    },
    {
      field: 'createdAt',
      headerName: 'Created',
      width: 160,
      renderCell: (params) => formatDate(params.row.createdAt),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleViewRide(params.row)}>
            <Visibility fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="error"
            onClick={() => handleDeleteRide(params.row.id)}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  // Map Component with improved centering
  const MapComponent = () => (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={mapZoom}
        onLoad={(map) => {
          mapRef.current = map;
          // Auto-fit bounds after map loads
          setTimeout(() => {
            if (selectedRide && selectedRide.pickupLat && selectedRide.dropLat) {
              fitBounds();
            }
          }, 500);
        }}
        options={{
          mapTypeControl: true,
          streetViewControl: true,
          fullscreenControl: true,
          zoomControl: true,
        }}
      >
        {directionsLoading && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'white',
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              zIndex: 1000,
            }}
          >
            <CircularProgress size={24} />
            <Typography variant="body2" sx={{ mt: 1 }}>
              Loading route...
            </Typography>
          </Box>
        )}

        {directions && directions.routes && directions.routes.length > 0 && (
          <DirectionsRenderer
            directions={directions}
            options={{
              polylineOptions: {
                strokeColor: "#2196F3",
                strokeWeight: 5,
                strokeOpacity: 0.8,
              },
              markerOptions: {
                visible: false, // Hide default markers
              },
              suppressMarkers: true,
            }}
          />
        )}
        
        {selectedRide && (
          <>
            {/* Pickup Marker with Info Window */}
            {selectedRide.pickupLat && selectedRide.pickupLng && (
              <>
                <Marker
                  position={{
                    lat: parseFloat(selectedRide.pickupLat),
                    lng: parseFloat(selectedRide.pickupLng),
                  }}
                  onClick={() => setShowInfoWindow('pickup')}
                  icon={{
                    path: window.google?.maps?.SymbolPath?.CIRCLE,
                    fillColor: "#4CAF50",
                    fillOpacity: 1,
                    scale: 12,
                    strokeColor: "#FFFFFF",
                    strokeWeight: 3,
                  }}
                />
                {showInfoWindow === 'pickup' && (
                  <InfoWindow
                    position={{
                      lat: parseFloat(selectedRide.pickupLat),
                      lng: parseFloat(selectedRide.pickupLng),
                    }}
                    onCloseClick={() => setShowInfoWindow(null)}
                  >
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" color="success.main">
                        📍 Pickup Location
                      </Typography>
                      <Typography variant="body2">
                        {selectedRide.pickupLocation || 'N/A'}
                      </Typography>
                    </Box>
                  </InfoWindow>
                )}
              </>
            )}
            
            {/* Drop Marker with Info Window */}
            {selectedRide.dropLat && selectedRide.dropLng && (
              <>
                <Marker
                  position={{
                    lat: parseFloat(selectedRide.dropLat),
                    lng: parseFloat(selectedRide.dropLng),
                  }}
                  onClick={() => setShowInfoWindow('drop')}
                  icon={{
                    path: window.google?.maps?.SymbolPath?.CIRCLE,
                    fillColor: "#F44336",
                    fillOpacity: 1,
                    scale: 12,
                    strokeColor: "#FFFFFF",
                    strokeWeight: 3,
                  }}
                />
                {showInfoWindow === 'drop' && (
                  <InfoWindow
                    position={{
                      lat: parseFloat(selectedRide.dropLat),
                      lng: parseFloat(selectedRide.dropLng),
                    }}
                    onCloseClick={() => setShowInfoWindow(null)}
                  >
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" color="error.main">
                        📍 Drop Location
                      </Typography>
                      <Typography variant="body2">
                        {selectedRide.dropLocation || 'N/A'}
                      </Typography>
                    </Box>
                  </InfoWindow>
                )}
              </>
            )}

            {/* Midpoint Marker */}
            {selectedRide.pickupLat && selectedRide.dropLat && (
              <Marker
                position={mapCenter}
                icon={{
                  path: window.google?.maps?.SymbolPath?.CIRCLE,
                  fillColor: "#FF9800",
                  fillOpacity: 0.7,
                  scale: 8,
                  strokeColor: "#FFFFFF",
                  strokeWeight: 2,
                }}
                onClick={() => setShowInfoWindow('midpoint')}
              />
            )}

            {showInfoWindow === 'midpoint' && (
              <InfoWindow
                position={mapCenter}
                onCloseClick={() => setShowInfoWindow(null)}
              >
                <Box sx={{ p: 1 }}>
                  <Typography variant="subtitle2" color="warning.main">
                    🎯 Midpoint
                  </Typography>
                  <Typography variant="body2">
                    Center of route
                  </Typography>
                </Box>
              </InfoWindow>
            )}
          </>
        )}
      </GoogleMap>
    </LoadScript>
  );

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Rides
        </Typography>
        <Typography variant="body2" color="text.secondary">
          View and manage all rides
        </Typography>
      </Box>

      {error && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          {error} - Showing demo data
        </Alert>
      )}

      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search by CRN, passenger, or driver..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') fetchRides(); }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{ flexGrow: 1, minWidth: 200 }}
            />
            <FormControl sx={{ minWidth: 180 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="searching_driver">Searching Driver</MenuItem>
                <MenuItem value="driver_assigned">Driver Assigned</MenuItem>
                <MenuItem value="in_progress">In Progress</MenuItem>
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <DataGrid
            rows={rides}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            autoHeight
            loading={loading}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* View Ride Dialog with Map */}
      <Dialog 
        open={openDialog} 
        onClose={() => setOpenDialog(false)} 
        maxWidth="lg" 
        fullWidth
        PaperProps={{
          sx: { height: '90vh' }
        }}
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="h6">
                Ride Details
                {selectedRide?.crn && (
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1, fontFamily: 'monospace' }}>
                    {selectedRide.crn}
                  </Typography>
                )}
              </Typography>
              {selectedRide && getStatusChip(selectedRide.status)}
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Chip 
                icon={<LocationOn />} 
                label={`${selectedRide?.distance || 0} km`} 
                color="primary" 
                size="small" 
              />
              <Button
                size="small"
                startIcon={<MyLocation />}
                onClick={() => {
                  if (selectedRide) {
                    const pickupLat = parseFloat(selectedRide.pickupLat);
                    const pickupLng = parseFloat(selectedRide.pickupLng);
                    const dropLat = parseFloat(selectedRide.dropLat);
                    const dropLng = parseFloat(selectedRide.dropLng);
                    const midpoint = calculateMidpoint(pickupLat, pickupLng, dropLat, dropLng);
                    setMapCenter(midpoint);
                    const distance = calculateDistance(pickupLat, pickupLng, dropLat, dropLng);
                    setMapZoom(calculateZoomLevel(distance));
                  }
                }}
              >
                Center Map
              </Button>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRide && (
            <Box>
              {/* Tabs */}
              <Tabs 
                value={mapTab} 
                onChange={(e, v) => setMapTab(v)}
                sx={{ mb: 2 }}
              >
                <Tab icon={<Place />} label="Route Map" />
                <Tab icon={<Directions />} label="Route Details" />
              </Tabs>

              {mapTab === 0 && (
                <Paper elevation={3} sx={{ p: 1, mb: 2 }}>
                  {/* Map with centered view */}
                  <MapComponent />
                  
                  {/* Map Legend and Controls */}
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mt: 1,
                    flexWrap: 'wrap',
                    gap: 1
                  }}>
                    <Box display="flex" gap={2} flexWrap="wrap">
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box sx={{ 
                          width: 16, 
                          height: 16, 
                          borderRadius: '50%', 
                          bgcolor: '#4CAF50',
                          border: '2px solid white'
                        }} />
                        <Typography variant="body2">Pickup</Typography>
                      </Box>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box sx={{ 
                          width: 16, 
                          height: 16, 
                          borderRadius: '50%', 
                          bgcolor: '#F44336',
                          border: '2px solid white'
                        }} />
                        <Typography variant="body2">Drop</Typography>
                      </Box>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box sx={{ 
                          width: 16, 
                          height: 16, 
                          borderRadius: '50%', 
                          bgcolor: '#FF9800',
                          border: '2px solid white'
                        }} />
                        <Typography variant="body2">Midpoint</Typography>
                      </Box>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box sx={{ 
                          width: 30, 
                          height: 4, 
                          bgcolor: '#2196F3',
                          borderRadius: 1
                        }} />
                        <Typography variant="body2">Route</Typography>
                      </Box>
                    </Box>
                    
                    {selectedRide && (
                      <Typography variant="caption" color="text.secondary">
                        Click on markers for location details
                      </Typography>
                    )}
                  </Box>
                </Paper>
              )}

              {mapTab === 1 && (
                <Paper elevation={3} sx={{ p: 2, mb: 2, maxHeight: 400, overflow: 'auto' }}>
                  <Typography variant="h6" gutterBottom>Route Details</Typography>
                  
                  {directions && directions.routes && directions.routes[0] ? (
                    <Box>
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={12} sm={6}>
                          <Paper sx={{ p: 2, bgcolor: 'success.light', color: 'success.contrastText' }}>
                            <Typography variant="caption">Pickup</Typography>
                            <Typography variant="body2" fontWeight="bold">
                              {selectedRide.pickupLocation}
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Paper sx={{ p: 2, bgcolor: 'error.light', color: 'error.contrastText' }}>
                            <Typography variant="caption">Drop</Typography>
                            <Typography variant="body2" fontWeight="bold">
                              {selectedRide.dropLocation}
                            </Typography>
                          </Paper>
                        </Grid>
                      </Grid>

                      <Box sx={{ display: 'flex', gap: 3, mb: 2, flexWrap: 'wrap' }}>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Total Distance</Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {directions.routes[0].legs[0].distance?.text || 'N/A'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Duration</Typography>
                          <Typography variant="body1" fontWeight="bold">
                            {directions.routes[0].legs[0].duration?.text || 'N/A'}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="caption" color="text.secondary">Fare</Typography>
                          <Typography variant="body1" fontWeight="bold" color="primary.main">
                            ₹{selectedRide.fare || selectedRide.finalFare || selectedRide.estimatedFare || 0}
                          </Typography>
                        </Box>
                      </Box>
                      
                      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                        Step-by-step directions:
                      </Typography>
                      {directions.routes[0].legs[0].steps.map((step, index) => (
                        <Box key={index} sx={{ 
                          p: 1.5, 
                          mb: 1, 
                          bgcolor: 'grey.50', 
                          borderRadius: 1,
                          borderLeft: '3px solid #2196F3',
                          '&:hover': {
                            bgcolor: 'grey.100',
                          }
                        }}>
                          <Typography 
                            variant="body2" 
                            dangerouslySetInnerHTML={{ __html: step.instructions }} 
                          />
                          <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              📏 {step.distance?.text}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              ⏱️ {step.duration?.text}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Alert severity="info">
                      {directionsLoading ? 'Loading directions...' : 'No route information available'}
                    </Alert>
                  )}
                </Paper>
              )}

              {/* Ride Summary Card */}
              <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="caption" color="text.secondary">Passenger</Typography>
                    <Typography variant="body2" fontWeight="500">
                      {selectedRide.passengerName || '-'}
                    </Typography>
                    {selectedRide.passengerPhone && (
                      <Typography variant="caption" color="text.secondary">
                        {selectedRide.passengerPhone}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="caption" color="text.secondary">Driver</Typography>
                    <Typography variant="body2" fontWeight="500">
                      {selectedRide.driverName || 'Not assigned'}
                    </Typography>
                    {selectedRide.driverPhone && (
                      <Typography variant="caption" color="text.secondary">
                        {selectedRide.driverPhone}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="caption" color="text.secondary">Vehicle</Typography>
                    <Typography variant="body2" fontWeight="500">
                      {selectedRide.vehicleType || '-'}
                    </Typography>
                    {selectedRide.vehicleNumber && (
                      <Typography variant="caption" color="text.secondary">
                        {selectedRide.vehicleNumber}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RidesPage;